window.o_global = window.o_global || {};
window.o_util = window.o_util || {};

// Sets the document.referrer to a global JS namespace.
o_global.referrer = document.referrer;

// Further legacy mappings. No clue what they're for...
o_global.getCookieValue = o_global.helper.getCookieValue;
o_global.convertStringToFunction = o_global.helper.convertStringToFunction;
o_global.isResponsive = o_global.helper.isResponsive;
